import { render, staticRenderFns } from "./StudentSettingSidebar.vue?vue&type=template&id=309c5542&scoped=true&"
import script from "./StudentSettingSidebar.vue?vue&type=script&lang=js&"
export * from "./StudentSettingSidebar.vue?vue&type=script&lang=js&"
import style0 from "./StudentSettingSidebar.vue?vue&type=style&index=0&id=309c5542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309c5542",
  null
  
)

export default component.exports